import { Component, OnInit, Input, Output, EventEmitter, forwardRef, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { GeneralService } from "../services/general.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-recherche',
  templateUrl: './recherche.component.html',
  styleUrls: ['./recherche.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RechercheComponent),
      multi: true
    }
  ]
})
export class RechercheComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() recherche: string;
  @Input() param: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() additionalColumns: any[] = []; // Array of additional column names to display in the dropdown

  @Output() ChampEnter: EventEmitter<any> = new EventEmitter<any>();
  @Output() ChampBlur: EventEmitter<string> = new EventEmitter<string>();

  parentVal: string = "";
  row: any;
  tbrecherche: any[] = [];
  items: any[] = []; // Replaced MatTableDataSource with native list arrays
  loading = true;
  exist = false;
  isOpen = false; // Tracks custom dropdown open panel toggles
  _param = "";
  public urlApi = this.generalService.api;

  constructor(
    private router: Router,
    private http: HttpClient,
    public generalService: GeneralService
  ) { }

  ngOnInit() {
    if (this.generalService.userConnecter === "") {
      this.router.navigate([""]);
    }
  }

  ngAfterViewInit() {
    this.rechercheTable(this.recherche).subscribe(data => {
      console.log(data);

      this.tbrecherche = data.TableRD;

      this.rechercheData(this.recherche, "").subscribe(data => {
        this.items = data;
        this.exist = true;
      });
    });

    console.log(this.tbrecherche);

  }
  getAltArticle(article: any): string {
    return (article?.Art_Code || '') + ' : ' + (article?.Art_Des || '');
  }
  getImageUrl(article: any): string {
    if (!article) return ''; // or a placeholder image URL
    let imageUrl = '';

    if (article.File_Content != null) {
      imageUrl = `${this.generalService.base_url}/images/${article.File_Content.trim()}`;
    }
    return imageUrl;
  }
  keyenter(newHero: string) {
    if (newHero) {
      // Logic space can remain blank or map to dynamic selections
    }
  }

  handleBlur() {
    // Small delay ensures click selection processes before list collapses
    setTimeout(() => {
      this.isOpen = false;
    }, 200);
    this.ChampBlur.emit(this.parentVal);
  }

  focusFunction() {
    this.isOpen = true;
    if (this.param) {
      this.onModif("");
    }
  }

  selectRow(row: any) {
    console.log(row);

    this.row = row;
    this.parentVal = this.setTextInput(row);
    console.log(this.parentVal);

    this._onChange(this.parentVal);
    this.ChampEnter.emit(row);
    this.isOpen = false;
  }

  clearInput() {
    this.parentVal = '';
    this._onChange('');
    this.onModif('');
  }

  rechercheData(codetb: string, codeval: string) {
    let v1 = "";
    let v2 = "";
    if (codeval) v1 = '&val=' + codeval;
    if (this.param) v2 = '&param=' + this.param;

    return this.http.get<any[]>(this.urlApi + 'recherche/tbdata?tablere=' + codetb + v1 + v2);
  }

  rechercheTable(code: string) {
    return this.http.get<any>(this.urlApi + 'recherche/TbRecherche?param=' + code);
  }

  onModif(event: any) {
    this.rechercheData(this.recherche, event).subscribe(data => {
      this.items = data;
      this.exist = data.length > 0;
    });
    this._onChange(event);
  }

  // ControlValueAccessor Boilerplate Functions
  private _onChange = (_: any) => { };
  private _onTouched = () => { };

  public writeValue(val: any) {
    if (val !== undefined && val !== null) {
      this.parentVal = val;
    }
  }

  setTextInput(cat: any): string {
    if (cat) {
      this.row = cat;
      return cat.Art_Des || '';
    }
    return '';
  }
  get gridTemplateColumns(): string {
    return `repeat(${this.tbrecherche.length || 1}, minmax(0, 1fr))`;
  }

  isImageColumn(item: any): boolean {
    return item.TableRD_Des === 'Image';
  }
  public registerOnChange(fn: (_: any) => void): void { this._onChange = fn; }
  public registerOnTouched(fn: () => void): void { this._onTouched = fn; }
}